import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/interval';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import { SessionObject, ProjectUtils } from '../../utility';
import { interval } from 'rxjs';

import { Router } from '@angular/router';

@Injectable()
export class SessionExpService {

      CHECKINTERVAL = 1000 * 1; // ms
      TIMEOUT_LIMIT = 3000;  // in sec  30mins
      NAME_SESSION_TIMER = 'TIMER';

      myInterval: Observable<any> = interval(this.CHECKINTERVAL);
      SubMyInterval: Subscription;
      LogOutAtTimeOut: Subject<any> = new Subject<any>();

      private manualLogoutFlag: boolean = false;

      constructor(
            private router: Router
      ) {
      }

      clearSession() {
            ProjectUtils.clearSessionObjects();
      }

      autoLogout(): void {
            this.LogOutAtTimeOut.next(this.SubMyInterval);
      }

      getTimeOutDateTime(): number {
            const dateTime = parseInt(localStorage.getItem(this.NAME_SESSION_TIMER), 10);
            return isNaN(dateTime) ? 0 : dateTime;
      }


      setSessionTimer() {
            const dateTime = Date.now();
            localStorage.setItem(this.NAME_SESSION_TIMER, dateTime.toString());
      }

      isExp(): Promise<boolean> {
            return new Promise((resolve, reject) => {
                  const currentTime = Date.now();
                  const dateTimeDiff = (currentTime - this.getTimeOutDateTime()) / 1000;

                  if (dateTimeDiff > this.TIMEOUT_LIMIT) {
                        ProjectUtils.unsubscribe(this.SubMyInterval);
                        localStorage.removeItem(this.NAME_SESSION_TIMER);
                        resolve(true);
                  }
                  reject(false);
            });
      }


      sub_SESSION_TIMER() {
            this.isTimerSubClosed()
                  .then(() => {
                        this.SubMyInterval = this.myInterval
                              .subscribe(() => {
                                    this.isExp()
                                          .then(() => {
                                                this.autoLogout();
                                                this.router.navigate([""])
                                                      ;
                                          })
                                          .catch(() => {

                                          });
                              });
                  })
                  .catch(() => {
                        // console.log('Running sub_SESSION_TIMER');
                  });
      }


      checkUserNSub_SESSION_TIMER() {
            //  const sessionObj: SessionObject = ProjectUtils.getSessionObject();

            // this.userDetails = SessionObject.getUserDetails();
            const userDetails = SessionObject.getUserDetails();

            if (userDetails && userDetails.userId) {
                  this.setSessionTimer();
                  this.sub_SESSION_TIMER();
            }
      }

      isTimerSubClosed() {
            return new Promise((resolve, reject) => {
                  if (this.SubMyInterval) {
                        if (this.SubMyInterval.closed) {
                              resolve(true);
                        }
                  } else {
                        resolve(false);
                  }
                  reject();
            });
      }

      markManualLogout() {
            this.manualLogoutFlag = true;
      }

      isManualLogout(): boolean {
            return this.manualLogoutFlag;
      }

      clearManualLogoutFlag() {
            this.manualLogoutFlag = false;
      }


}

